<template>
  <el-container>
    <el-header height="auto" class="el-header">
      <headerView />
    </el-header>
    <el-main class="el-main">
      <div class="ch-container">
        <el-card style="padding:30px">
          <steps-view :steps="steps" :active="active" />
          <agreement-view v-if="active==0" @agree="onSteps(1)" />
          <info-view v-if="active==1" @complete="onSteps(2)" @prev="onSteps(0)"/>
          <complete-view v-if="active==2"/>
        </el-card>
      </div>
    </el-main>
    <el-footer height="auto" class="el-footer">
      <page-footer />
    </el-footer>
  </el-container>
</template>
<script>
import headerView from "./header";
import pageFooter from "../../layout/components/pageFooter";
import stepsView from "./steps";
import agreementView from "./agreement";
import infoView from "./info";
import completeView from "./complete";
export default {
  data() {
    return {
      active: 0,
      steps: [
        { label: "服务条款" },
        { label: "创建用户" },
        { label: "创建成功" },
      ],
    };
  },
  components: {
    pageFooter,
    headerView,
    stepsView,
    agreementView,
    infoView,
    completeView
  },
  methods: {
    onSteps(index) {
      this.active = index;
    },

    register(index){
      this.active = index;
    }
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #ffffff;
}
.el-main {
}
.el-footer {
  padding: 0;
}
</style>